class UnauthorizedError extends Error {}

export default UnauthorizedError
